import styled from 'styled-components';

const StyledFooterWrapper = styled.div`
  margin-top: 1rem;
  background-color: ${(props) => props.theme.color.bodyTextColor};
  min-height: 300px;
`;

function Footer() {
  return <StyledFooterWrapper />;
}

export { Footer };
